import { createFileRoute } from '@tanstack/react-router'

import { OrgAiPage } from '#/modules/agents/org-ai/org-ai-page'
import { validateListSearch } from '#/shared/lib/list-search'

// Open alongside the playground while the catalogue pages stay switched off:
// per-organization AI switches, daily limits and spend.
export const Route = createFileRoute('/_shell/org-ai')({
  component: OrgAiPage,
  validateSearch: validateListSearch,
})
